import Select from 'react-select'
import Label from './Label';
import Input from './Input';

const IsRequiredField = ({isRequired, value, isSubmitted}) => {
    return(
      <>
        {isRequired&&!value&&isSubmitted&&<span className="block text-xs text-red-500"> This field is required </span>}
      </>
    )
}

const IsRequiredFieldSelect = ({isRequired, value, isSubmitted}) => {
    return(
      <>
        {isRequired&&value?.length==0&&isSubmitted&&<span className="block text-xs text-red-500"> This field is required </span>}
      </>
    )
}


const FirstName = ({value, readOnly, onChange, isSubmitted, isRequired}) => {

    return (
        <div>
            <Label isRequired={isRequired}>Firstname</Label>
            <Input 
                type="text" 
                required
                value={value}
                onChange={onChange}
                disabled={readOnly}
                readOnly={readOnly}
            />
            <IsRequiredField 
                value={value} 
                isRequired={isRequired} 
                isSubmitted={isSubmitted} 
            />
        </div>
    )
  
}

const LastName = ({value, fieldName="Lastname", readOnly, onChange, isSubmitted, isRequired=false}) => {

    return (
        <div>
            <Label isRequired={isRequired}>{fieldName}</Label>
            <Input 
                type="text" 
                required
                value={value}
                onChange={onChange}
                disabled={readOnly}
                readOnly={readOnly}
            />
            <IsRequiredField 
                value={value} 
                isRequired={isRequired} 
                isSubmitted={isSubmitted} 
            />
        </div>
    )
}


const Gender = ({value, myRef, readOnly, defaultValue, options, onChange, isSubmitted, isRequired=false}) => {

    return (
        <div className="space-y-2">
            <Label isRequired={isRequired}>Gender</Label>
            <Select 
                ref={myRef} 
                placeholder="Select gender" 
                options={options} 
                isDisabled={readOnly}
                defaultValue={defaultValue&&{value: defaultValue, label: defaultValue}}
                onChange={onChange} 
            />
            <IsRequiredField 
                value={value} 
                isRequired={isRequired} 
                isSubmitted={isSubmitted} 
            />

        </div>
    )
  
}

const WebSiteLink = ({value, readOnly, showHelpLink, onClick, onChange, isSubmitted, isRequired=false}) => {

    return (
        <div>
            <Label isRequired={isRequired}>WebSite link
                <button  className="ml-1 text-red-400 text-sm" onClick={onClick}>
                    (?)
                </button>
                <span className="ml-2 text-sm text-red-600">
                   ( Press enter to add new link )
                </span>
            </Label>
            {showHelpLink&&
                <p className="text-xs text-gray-600">
                    Copy here a url referring to the official website of the composer, 
                    to a website dedicated to this composer or to the wikipedia page dedicated to the composer
                </p>
            }
            <Input 
                type="url" 
                value={value}
                onChange={onChange}
                disabled={readOnly}
                readOnly={readOnly}
            />
            <IsRequiredField 
                value={value} 
                isRequired={isRequired} 
                isSubmitted={isSubmitted} 
            />
        </div>
    )
  
}

const Nationality = ({value, readOnly, defaultValue, myRef, options, onChange, isSubmitted, isRequired=false}) => {
    return (
        <div className="space-y-2">
            <Label isRequired={isRequired}>Nationality</Label>
            <Select
                onChange={onChange}
                ref={myRef}
                getOptionLabel={option =>`${option.countries}`}
                getOptionValue={option =>`${option.countries}`}
                isMulti
                defaultValue={defaultValue}
                placeholder="Select nationality..."
                options={options}
                className="basic-multi-select"
                classNamePrefix="select"
                isDisabled={readOnly}
            /> 
            <IsRequiredFieldSelect
                value={value} 
                isRequired={isRequired} 
                isSubmitted={isSubmitted} 
            />
        </div>
    )
  
}

const Notes = ({value, readOnly, refMessage, onChange, isSubmitted, isRequired=false}) => {

    return (
        <div className="flex flex-col space-y-3">
            <Label isRequired={isRequired}>Notes</Label>
            <textarea
                type="text"
                ref={refMessage}
                onChange={onChange}
                maxLength="255"
                defaultValue={value}
                disabled={readOnly}
                readOnly={readOnly}
                className="h-40 text-base leading-none text-gray-900 p-3 focus:oultine-none focus:border-blue-700 mt-4 bg-white border border-gray-200 focus:ring-0 focus:shadow-none focus:outline-none focus:border-none"
                ></textarea>
            <IsRequiredField 
                value={value} 
                isRequired={isRequired} 
                isSubmitted={isSubmitted} 
            />
        </div>
    )
}

const DateOfBirth = ({value, readOnly, onChange, isSubmitted, isRequired=false}) => {

    return (
        <div>
            <Label isRequired={isRequired}>Date of birth (DD/MM/YYYY or YYYY)</Label>
            <Input 
                type="text" 
                value={value}
                onChange={onChange}
                disabled={readOnly}
                readOnly={readOnly}
            />
            <IsRequiredField 
                value={value} 
                isRequired={isRequired} 
                isSubmitted={isSubmitted} 
            />
        </div>
    )
  
}

const DateOfDeath = ({value, readOnly, onChange, isSubmitted, isRequired=false}) => {

    return (
        <div>
            <Label isRequired={isRequired}>Date of death (DD/MM/YYYY or YYYY)</Label>
            <Input 
                type="text" 
                value={value}
                onChange={onChange}
                disabled={readOnly}
                readOnly={readOnly}
            />
            <IsRequiredField 
                value={value} 
                isRequired={isRequired} 
                isSubmitted={isSubmitted} 
            />
        </div>
    )
  
}

export {
    FirstName,
    LastName,
    Gender,
    WebSiteLink,
    Nationality,
    Notes,
    DateOfBirth,
    DateOfDeath
}
